import { Reducer } from 'redux';
import { ActionType, getType } from 'typesafe-actions';
import { IGameState } from '../Game/IGameState';
import { PlinkoActions } from './PlinkoActions';
import {
    buyPlinkoToken,
    claimPlinkoReward,
    dropPlinkoToken,
    leavePlinkoScene,
    setRewardAnimationComplete,
    setPlinkoRewardClaimable,
} from './PlinkoStateHelper';

export const PlinkoReducer: Reducer<IGameState> = (
    state: IGameState,
    action: ActionType<typeof PlinkoActions>
): IGameState => {
    return handleAction(state, action);
};

function handleAction(state: IGameState, action: ActionType<typeof PlinkoActions>): IGameState {
    switch (action.type) {
        case getType(PlinkoActions.dropToken):
            return dropPlinkoToken(state, action.payload);
        case getType(PlinkoActions.buyToken):
            return buyPlinkoToken(state, action.payload);
        case getType(PlinkoActions.setRewardClaimable):
            return setPlinkoRewardClaimable(state);
        case getType(PlinkoActions.rewardAnimationComplete):
            return setRewardAnimationComplete(state);
        case getType(PlinkoActions.claimReward):
            return claimPlinkoReward(state);
        case getType(PlinkoActions.leavePlinkoScene):
            return leavePlinkoScene(state);
        default:
            return state;
    }
}
